import React, { useState, useEffect } from "react";



import { Link } from "react-router-dom";
import db from "./Firebase";
import { collection, onSnapshot } from "firebase/firestore";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from "chart.js";
import { Bar } from "react-chartjs-2";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { format } from "date-fns";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

function DashboardAll() {
    const [totalUsers, setTotalUsers] = useState(0);
    const [dailyActiveUsers, setDailyActiveUsers] = useState(0);
    const [engagementCount, setEngagementCount] = useState(0);
    const [categoryData, setCategoryData] = useState(null);
    const [inactiveUsers, setInactiveUsers] = useState(0);

    const [dateRange, setDateRange] = useState("7d"); // Default: Last 7 Days
    const [showCalendar, setShowCalendar] = useState(false);
    const [customDate, setCustomDate] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: "selection"
        }
    ]);

    const [showPicker, setShowPicker] = useState(false);

    const getStartDate = () => {
        const now = new Date();
        switch (dateRange) {
            case "1d": return new Date(now.setDate(now.getDate() - 1));
            case "7d": return new Date(now.setDate(now.getDate() - 7));
            case "30d": return new Date(now.setDate(now.getDate() - 30));
            case "90d": return new Date(now.setDate(now.getDate() - 90));
            case "1y": return new Date(now.setFullYear(now.getFullYear() - 1));
            case "custom": return customDate[0].startDate;
            default: return new Date(now.setDate(now.getDate() - 7));
        }
    };

    useEffect(() => {
        const unsubscribe = onSnapshot(collection(db, "users_activity"), (snapshot) => {
            let users = snapshot.docs.map(doc => doc.data());
            setTotalUsers(users.length || 0);

            const startDate = getStartDate();
            let endDate = dateRange === "custom" ? new Date(customDate[0].endDate) : new Date();

            // Ensure endDate includes the full day (23:59:59)
            endDate.setHours(23, 59, 59, 999);

            console.log("Adjusted Start Date:", startDate);
            console.log("Adjusted End Date:", endDate);

            let filteredUsers = users.filter(user => {
                const lastActive = user.last_active?.toDate();
                return lastActive >= startDate && lastActive <= endDate;
            });

            let activeUsers = filteredUsers.length;
            let inactiveUsers = users.length - activeUsers; // Should subtract from total users
            let inquisitiveUsers = filteredUsers.filter(user => user.is_inquisitive).length;

            // let categoryCount = {};
            // filteredUsers.forEach(user => {
            //     if (user.page_visits) {
            //         user.page_visits.forEach(visit => {
            //             categoryCount[visit.category] = (categoryCount[visit.category] || 0) + 1;
            //         });
            //     }
            // });

            let categoryCount = {};
            users.forEach(user => {
                if (user.page_visits) {
                    user.page_visits.forEach(visit => {
                        const visitTime = visit.visit_time?.toDate(); // Convert Firestore timestamp to JS Date

                        // Only count visits within the selected date range
                        if (visitTime >= startDate && visitTime <= endDate) {
                            categoryCount[visit.category] = (categoryCount[visit.category] || 0) + 1;
                        }
                    });
                }
            });

            setCategoryData(
                Object.keys(categoryCount).length === 0
                    ? null
                    : {
                        labels: Object.keys(categoryCount),
                        datasets: [
                            {
                                data: Object.values(categoryCount),
                                backgroundColor: ["#FF9800", "#3F51B5", "#009688", "#9C27B0"]
                            }
                        ]
                    }
            );

            setDailyActiveUsers(activeUsers || 0);
            setInactiveUsers(inactiveUsers || 0);
            setEngagementCount(inquisitiveUsers || 0);
        });

        return () => unsubscribe();
    }, [dateRange, customDate]);



    const cards = [
        { value: totalUsers, label: "Total Users", gradient: "from-teal-400 to-green-500" },
        { value: dailyActiveUsers, label: "Daily Active Users", gradient: "from-blue-400 to-blue-600" },
        { value: inactiveUsers, label: "Inactive Users", gradient: "from-red-400 to-red-600" },
        { value: engagementCount, label: "Inquisitive Users", gradient: "from-purple-400 to-purple-600" },
    ];



    return (
        <>
            {/* Navbar */}
            <div className="p-2 flex justify-between">
                <Link to="/">
                    <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
                </Link>
            </div>
            <div className="card-header pb-0 px-3 d-flex justify-content-end">

                <Link to="/analytics_preview">
                    <button className="btn btn-success btn-sm mr-3" >
                        Analytics Preview
                    </button>
                </Link>
                <Link to="/page_visit">
                    <button className="btn btn-success btn-sm mr-3" >
                        User Page Visits Logs
                    </button>
                </Link>
                <Link to="/analytics_details">
                    <button className="btn btn-success btn-sm" >
                        User Analytics (Real-Time)
                    </button>
                </Link>

            </div>

            {/* Date Filter Dropdown */}
            <div className="flex gap-2 mb-4 px-4 relative mt-3">
                <select
                    className="border p-2 rounded-md"
                    value={dateRange}
                    onChange={(e) => {
                        setDateRange(e.target.value);
                        if (e.target.value === "custom") setShowCalendar(true);
                        else setShowCalendar(false);
                    }}
                >
                    <option value="1d">Daily</option>
                    <option value="7d">Last 7 Days</option>
                    <option value="30d">Last 30 Days</option>
                    <option value="90d">Last 90 Days</option>
                    <option value="1y">One Year</option>
                    <option value="custom">Custom</option>
                </select>

                {/* Show Date Picker when "Custom" is selected */}
                {dateRange === "custom" && (
                    <div className="relative">
                        <button
                            className="border p-2 rounded-md bg-gray-100"
                            onClick={() => setShowCalendar(!showCalendar)}
                        >
                            {format(customDate[0].startDate, "MM/dd/yyyy")} - {format(customDate[0].endDate, "MM/dd/yyyy")}
                        </button>
                        <button
                            className="text-md text-red-500 hover:text-red-700 ml-3"
                            onClick={() => setShowCalendar(false)}
                        >
                            ✖ Close
                        </button>

                        {showCalendar && (
                            <div className="absolute top-10 left-0 z-10 bg-white shadow-md rounded-md mt-6">
                                <DateRangePicker
                                    ranges={customDate}

                                    onChange={(ranges) => {
                                        console.log("Start Date:", ranges.selection.startDate);
                                        console.log("End Date:", ranges.selection.endDate);
                                        setCustomDate([ranges.selection]);
                                    }}
                                />
                            </div>
                        )}
                    </div>
                )}

            </div>

            {/* Statistic Cards */}
            <section className="flex justify-between gap-4 p-2">
                {cards.map((card, index) => (
                    <div key={index} className={`relative p-3 bg-gradient-to-r ${card.gradient} rounded-lg shadow-md flex-1 min-w-[150px]`}>
                        <div className="text-white text-2xl font-semibold">{card.value}</div>
                        <div className="text-white text-sm font-medium opacity-80">{card.label}</div>
                    </div>
                ))}
            </section>



            {/* Category Wise Data Chart */}
            <div className="bg-white p-3 shadow-md rounded-md mt-4">
                <h3 className="text-base font-semibold mb-1 text-gray-700">Category Wise Data</h3>
                {categoryData ? <Bar data={categoryData} /> : <p className="text-sm text-gray-500">Loading...</p>}
            </div>
        </>
    );
}

export default DashboardAll;




// import React, { useState, useEffect } from "react";


// import { Link } from "react-router-dom";
// import db from "./Firebase";
// import { collection, onSnapshot } from "firebase/firestore";
// import { Chart as ChartJS, RadialLinearScale, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from "chart.js";
// import { PolarArea, Bar } from "react-chartjs-2";

// ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);
// // Register required components


// function DashboardAll() {
//     const [totalUsers, setTotalUsers] = useState(0);
//     const [dailyActiveUsers, setDailyActiveUsers] = useState(0);
//     const [engagementCount, setEngagementCount] = useState(0);
//     const [categoryData, setCategoryData] = useState(null);
//     const [InactiveUsers, setInactiveUsers] = useState(0)

//     useEffect(() => {
//         const unsubscribe = onSnapshot(collection(db, "users_activity"), (snapshot) => {
//             let users = snapshot.docs.map(doc => doc.data());
//             setTotalUsers(users.length || 0);

//             const now = new Date();
//             const sevenDaysAgo = new Date();
//             sevenDaysAgo.setDate(now.getDate() - 7);

//             let activeUsers = users.filter(user => user.last_active?.toDate() >= sevenDaysAgo).length;
//             let inactiveUsers = users.length - activeUsers;
//             let inquisitiveUsers = users.filter(user => user.is_inquisitive).length;

//             let categoryCount = {};
//             users.forEach(user => {
//                 if (user.page_visits) {
//                     user.page_visits.forEach(visit => {
//                         categoryCount[visit.category] = (categoryCount[visit.category] || 0) + 1;
//                     });
//                 }
//             });

//             setCategoryData({
//                 labels: Object.keys(categoryCount),
//                 datasets: [{ data: Object.values(categoryCount), backgroundColor: ["#FF9800", "#3F51B5", "#009688", "#9C27B0"] }]
//             });

//             // setCategoryData({
//             //     labels: Object.keys(categoryCount),
//             //     datasets: [{
//             //         data: Object.values(categoryCount),
//             //         backgroundColor: ["#FF9800", "#3F51B5", "#009688", "#9C27B0"]
//             //     }]
//             // });

//             setDailyActiveUsers(activeUsers || 0);
//             setInactiveUsers(inactiveUsers || 0);
//             setEngagementCount(inquisitiveUsers || 0);
//         });

//         return () => unsubscribe();
//     }, []);


//     const cards = [
//         {
//             value: totalUsers, label: "Total Users", gradient: "from-teal-400 to-green-500", icon: (
//                 <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth="2"
//                     d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
//                 />
//             ),
//         },
//         {
//             value: dailyActiveUsers, label: "Daily Active Users", gradient: "from-blue-400 to-blue-600", icon: (
//                 <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth="2"
//                     d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
//                 />
//             ),
//         },
//         {
//             value: InactiveUsers, label: "Inactive Users", gradient: "from-red-400 to-red-600", icon: (
//                 <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth="2"
//                     d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
//                 />
//             ),
//         },
//         {
//             value: engagementCount, label: "Inquisitive", gradient: "from-red-400 to-red-600", icon: (
//                 <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth="2"
//                     d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
//                 />
//             ),
//         },
//     ];

//     return (
//         <>
//             <div className="p-2 d-flex justify-content-between">
//                 <Link to="/">
//                     <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
//                 </Link>
//             </div>
//             <section className="flex justify-between gap-4 p-2">
//                 {cards.map((card, index) => (

//                     <div
//                         key={index}
//                         className={`relative p-3 bg-gradient-to-r ${card.gradient} rounded-lg overflow-hidden shadow-md flex-1 min-w-[150px]`}
//                     >
//                         <div className="text-white text-2xl font-semibold">{card.value}</div>
//                         <div className="text-white text-sm font-medium opacity-80">{card.label}</div>
//                         <svg
//                             fill="none"
//                             viewBox="0 0 24 24"
//                             stroke="currentColor"
//                             className="absolute right-2 bottom-2 h-20 w-20 opacity-40"
//                         >
//                             {card.icon}
//                         </svg>
//                     </div>

//                 ))}
//             </section>

//             <div className="bg-white p-3 shadow-md rounded-md mt-4">
//                 <h3 className="text-base font-semibold mb-1 text-gray-700">Category Wise Data</h3>
//                 {categoryData ? <Bar data={categoryData} /> : <p className="text-sm text-gray-500">Loading...</p>}
//             </div>
//             {/* <div className="bg-white p-3 shadow-md rounded-md mt-4">
//                 <h3 className="text-base font-semibold mb-1 text-gray-700">Category Wise Data</h3>
//                 {categoryData ? <PolarArea data={categoryData} /> : <p className="text-sm text-gray-500">Loading...</p>}
//             </div> */}

//         </>
//     );
// }

// export default DashboardAll;

